import axios from 'axios'

export const API_BASE = 'https://sistemarab.com/CasinoApp'

export function getToken() {
  return localStorage.getItem('casino_token') || ''
}

export function setToken(token) {
  localStorage.setItem('casino_token', token)
}

export function clearToken() {
  localStorage.removeItem('casino_token')
}

export const api = axios.create({
  baseURL: API_BASE,
})

api.interceptors.request.use((config) => {
  const token = getToken()
  if (token) config.headers.Authorization = `Bearer ${token}`
  return config
})
